import { render, staticRenderFns } from "./IssuesPerStatusPercent.vue?vue&type=template&id=180c9fd7"
import script from "./IssuesPerStatusPercent.vue?vue&type=script&lang=js"
export * from "./IssuesPerStatusPercent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports